import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  wrapper: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '40px',
    columnGap: '90px',
    padding: '0 50px',
    maxWidth: '1265px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
      flexDirection: 'column',
      rowGap: '20px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      rowGap: '20px',
    },
  },
  imageWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '253px',
    height: '253px',
    zIndex: 999,
    flexShrink: 0,
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      padding: '0 40px',
      alignItems: 'center',
    },
    [theme.breakpoints.down('md')]: {
      paddingRight: '20px',
    },
  },
  praiseHandsImage: {
    position: 'absolute',
    zIndex: 999,
    width: '100px',
    height: '100px',
    bottom: '-20px',
    right: '-50px',
    transform: 'rotate(45deg)',
    [theme.breakpoints.down('sm')]: {
      right: '-30px',
      bottom: 0,
    },
  },
  hideOnMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  hideOnDesktop: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
});
